"use client";

import { c as _c } from "react/compiler-runtime";
import FavoritesIcon from "@/Components/Common/Icons/FavoritesIcon";
import VerifyAccountIcon from "@/Components/Common/Icons/VerifyAccountIcon";
import WarningIcon from "@/Components/Common/Icons/WarningIcon";
import { useFindRepsFromLocationQuery } from "@/Redux/apis/reps";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import LoginPopup from "./LoginPopup";
import { usePathname } from "next/navigation";
import RepsDetailedPopup from "./RepsDetailedPopup";
import BookAppointments from "@/Components/DoctorsDashboard/Reps/BookAppointments/BookAppointments";
import SendMessage from "@/Components/DoctorsDashboard/Reps/SendMessage/SendMessage";
import { useSelector } from "react-redux";
import Avatar from "react-avatar";
import { sanitizeImageUrl } from "@/utils/imageUrl";
import { GoHeart, GoHeartFill } from "react-icons/go";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/Components/ui/tooltip";
import MapIcon from "@/Components/website/common/Icons/MapIcon";
import ProductsListingPopUp from "@/Components/Common/ProductList/ProductsListingPopUp";
import { useSearchProductsByIdsMutation } from "@/Redux/apis/product";
import { useRepFavourite } from "@/hooks/useFavourite";
import { toast } from "react-toastify";
import { withAlphaMdDefaultRep } from "./defaultRep";
import ManufacturerList from "./ManufacturerList";
import AlphaMdRepRequestPopup from "./AlphaMdRepRequestPopup";
import { repCompanyNames } from "@/utils/repCompanies";
const RepsListing = t0 => {
  const $ = _c(71);
  const {
    product,
    isLoggedIn,
    reps: serverReps,
    address: serverAddress,
    hideBorderAndHeading: t1
  } = t0;
  const hideBorderAndHeading = t1 === undefined ? false : t1;
  const users = useSelector(_temp);
  const isUserLoggedIn = isLoggedIn || !!users;
  const pathname = usePathname();
  const [activeRep, setActiveRep] = useState();
  const [isAppointmentOpen, setIsAppointmentOpen] = useState(false);
  const [isMsgOpen, setIsMsgOpen] = useState(false);
  const [isLoginPopUpOpen, setLoginPopup] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const [isRepsDetailedPopup, setRepsDetailedPopup] = useState(false);
  const [showList, setShowList] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [filteredList, setFilteredList] = useState(t2);
  const [load, setLoad] = useState(false);
  const [isAlphaRequestOpen, setIsAlphaRequestOpen] = useState(false);
  const {
    isFavourite,
    toggleFavourite
  } = useRepFavourite();
  const coords = users?.location?.coordinates;
  const userLat = coords?.[1] || 0;
  const userLng = coords?.[0] || 0;
  const hasServerReps = serverReps?.length > 0;
  const t3 = product?.id;
  let t4;
  if ($[1] !== t3 || $[2] !== userLat || $[3] !== userLng) {
    t4 = {
      productId: t3,
      latitude: userLat,
      longitude: userLng
    };
    $[1] = t3;
    $[2] = userLat;
    $[3] = userLng;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !isUserLoggedIn || !product?.id || hasServerReps;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      skip: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    data: repsData
  } = useFindRepsFromLocationQuery(t4, t6);
  const resolvedReps = hasServerReps ? serverReps : repsData?.data?.length > 0 ? repsData.data : serverReps;
  let t7;
  if ($[7] !== isUserLoggedIn || $[8] !== resolvedReps) {
    t7 = isUserLoggedIn ? withAlphaMdDefaultRep(resolvedReps) : Array.isArray(resolvedReps) ? resolvedReps : [];
    $[7] = isUserLoggedIn;
    $[8] = resolvedReps;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const reps = t7;
  const isShowingDefaultRep = reps.length === 1 && reps[0]?.isAlphaMdDefault;
  const address = repsData?.data?.length > 0 ? users?.addressDetails ? `${users.addressDetails.area || ""}, ${users.addressDetails.pincode || ""}` : serverAddress : serverAddress;
  const [searchProductsByIdsApi, searchProductsByIdsApiResponse] = useSearchProductsByIdsMutation();
  let t8;
  if ($[10] !== searchProductsByIdsApi) {
    t8 = async selectedRepProducts => {
      await searchProductsByIdsApi({
        ids: selectedRepProducts
      });
    };
    $[10] = searchProductsByIdsApi;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const getProductFromId = t8;
  let t9;
  if ($[12] !== searchProductsByIdsApiResponse?.data?.productslist || $[13] !== searchProductsByIdsApiResponse?.error?.data?.message || $[14] !== searchProductsByIdsApiResponse?.error?.status || $[15] !== searchProductsByIdsApiResponse?.isError || $[16] !== searchProductsByIdsApiResponse?.isLoading || $[17] !== searchProductsByIdsApiResponse?.isSuccess || $[18] !== searchProductsByIdsApiResponse?.status) {
    t9 = () => {
      if (searchProductsByIdsApiResponse?.isLoading) {
        setLoad(true);
      } else {
        if (!searchProductsByIdsApiResponse?.isLoading && searchProductsByIdsApiResponse?.isSuccess) {
          setFilteredList(searchProductsByIdsApiResponse?.data?.productslist.map(_temp2) || []);
          setLoad(false);
        } else {
          if (searchProductsByIdsApiResponse?.isError && searchProductsByIdsApiResponse?.status === "rejected" && searchProductsByIdsApiResponse?.error?.status === 400) {
            setLoad(false);
            toast.error(searchProductsByIdsApiResponse?.error?.data?.message);
          }
        }
      }
    };
    $[12] = searchProductsByIdsApiResponse?.data?.productslist;
    $[13] = searchProductsByIdsApiResponse?.error?.data?.message;
    $[14] = searchProductsByIdsApiResponse?.error?.status;
    $[15] = searchProductsByIdsApiResponse?.isError;
    $[16] = searchProductsByIdsApiResponse?.isLoading;
    $[17] = searchProductsByIdsApiResponse?.isSuccess;
    $[18] = searchProductsByIdsApiResponse?.status;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== searchProductsByIdsApiResponse) {
    t10 = [searchProductsByIdsApiResponse];
    $[20] = searchProductsByIdsApiResponse;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  useEffect(t9, t10);
  let t11;
  if ($[22] !== address || $[23] !== hideBorderAndHeading || $[24] !== isShowingDefaultRep || $[25] !== reps.length) {
    t11 = !hideBorderAndHeading && reps.length > 0 && <div className="text-[14px] sm:text-[16px] text-black font-poppins font-semibold"><div className="border border-dashed my-2 sm:my-3" /><div className="py-1 flex gap-2 items-center"><span className="shrink-0"><MapIcon /></span><span className="text-xs sm:text-base">{isShowingDefaultRep ? "Alpha.MD representative" : `Showing reps near ${address}`}</span></div></div>;
    $[22] = address;
    $[23] = hideBorderAndHeading;
    $[24] = isShowingDefaultRep;
    $[25] = reps.length;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== getProductFromId || $[28] !== isFavourite || $[29] !== isHidden || $[30] !== isUserLoggedIn || $[31] !== pathname || $[32] !== product?.manufacturers || $[33] !== product?.openfda?.manufacturer_name || $[34] !== reps || $[35] !== toggleFavourite) {
    t12 = isUserLoggedIn && reps ? <div><div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 w-full py-2">{(isHidden ? reps.slice(0, 2) : reps).map((rep, index) => {
          const openRepDetail = () => {
            if (rep.isAlphaMdDefault) {
              setIsAlphaRequestOpen(true);
              return;
            }
            setRepsDetailedPopup(true);
            setActiveRep(rep);
          };
          return <div key={index} onClick={openRepDetail} role="button" tabIndex={0} onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openRepDetail();
            }
          }} className="relative w-full p-2 sm:p-3 flex justify-between items-start rounded-lg border border-[#E1E1E1] cursor-pointer hover:border-[#354EF0]/60 hover:bg-[#354EF0]/[0.02] transition-colors"><div className="flex items-start gap-2 min-w-0 flex-1"><div className={`w-[36px] h-[36px] sm:w-[48px] sm:h-[48px] shrink-0 flex items-center justify-center ${rep.isAlphaMdDefault ? "overflow-visible" : "rounded-full overflow-hidden"}`}>{sanitizeImageUrl(rep.profile) ? <Image src={rep.profile} height={48} width={48} className={rep.isAlphaMdDefault ? "w-[34px] h-[34px] sm:w-[44px] sm:h-[44px] object-contain" : "rounded-full w-full h-full object-cover"} alt="profilePic" /> : <Avatar name={rep.repDetails.firstName} color="#354EF0" size="100%" round={true} />}</div><div className="space-y-1 sm:space-y-2 min-w-0 flex-1"><div><div className="flex items-center gap-2"><div className="text-[13px] sm:text-[16px] font-medium text-[#4B4B4B] font-poppins truncate">{rep.repDetails.firstName}{" "}{rep.repDetails.lastName}</div></div>{rep.isAlphaMdDefault ? <div className="text-[10px] sm:text-[12px] font-normal font-poppins text-[#8E8E8E]">Manufacturer:{" "}<ManufacturerList manufacturers={product?.manufacturers} fallback={product?.openfda?.manufacturer_name} /></div> : <div className="capitalize text-[10px] sm:text-[12px] font-normal font-poppins text-[#8E8E8E]">Manufacturer:{" "}<ManufacturerList manufacturers={repCompanyNames(rep)} fallback={rep.companyName} previewCount={1} /></div>}<div className="text-[10px] sm:text-[12px] font-normal font-poppins text-[#8E8E8E]">{rep.addressDetails.state},{" "}{rep.addressDetails.country}</div></div><div className="flex items-center gap-2 sm:gap-3"><div className="flex flex-wrap gap-1.5 sm:gap-2 text-black text-[12px] sm:text-[14px] font-medium font-poppins">{rep.repProducts.slice(0, 2).map(_temp4)}{rep.repProducts?.length > 2 && <p onClick={e_1 => {
                      e_1.stopPropagation();
                      setShowList(true);
                      getProductFromId(rep.repProducts.map(_temp5));
                    }} className="text-[10px] sm:text-xs border text-blue-600 h-5 w-5 sm:h-7 sm:w-7 rounded-full items-center justify-center flex cursor-pointer">+{rep.repProducts.length - 2}</p>}</div></div></div></div>{!rep.isAlphaMdDefault && <TooltipProvider><Tooltip><TooltipTrigger asChild={true}><span onClick={e_2 => {
                    e_2.stopPropagation();
                    toggleFavourite(e_2, rep.repDetails);
                  }} className="cursor-pointer aspect-square h-6 w-6 sm:h-8 sm:w-8 bg-[#F64C4C]/10 rounded-md flex items-center justify-center shrink-0">{isFavourite(rep.repDetails._id) ? <GoHeartFill color="#F64C4C" size={14} className="sm:w-4 sm:h-4" /> : <GoHeart color="#F64C4C" size={14} className="sm:w-4 sm:h-4" />}</span></TooltipTrigger><TooltipContent><p className="text-xs font-medium">{isFavourite(rep.repDetails._id) ? "Unfavorite the rep" : "Favorite the rep"}</p></TooltipContent></Tooltip></TooltipProvider>}</div>;
        })}</div>{reps.length > 2 && <div onClick={() => {
        setIsHidden(false);
      }} className="flex text-[14px] sm:text-[16px] font-semibold text-[#354EF0] font-poppins pt-3 sm:pt-4 cursor-pointer justify-center">Show more</div>}</div> : <div className="mt-5 relative w-full min-h-[200px] sm:h-[170px]"><div className="absolute inset-0 z-0 p-3 sm:p-6 text-[#4B4B4B] overflow-hidden"><div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 w-full py-2">{Array.from({
            length: 2
          }).map(_temp7)}</div></div><div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-black bg-opacity-40 backdrop-blur-lg rounded-lg px-4 sm:px-3 py-4 sm:py-0"><div className="text-white flex items-center gap-1.5 sm:gap-2"><div className="flex-shrink-0"><WarningIcon /></div><div className="text-[14px] sm:text-[24px] font-poppins text-white font-medium text-center leading-tight">Signup or Login to view Reps</div></div><div className="text-[10px] sm:text-[12px] pt-1 sm:pt-2 text-[#EEEEEE] font-medium text-center">You must have an account to view Reps detail</div><Link href={`/sign-up?redirect=${pathname}`}><button className="mt-2.5 sm:mt-4 px-4 sm:px-6 py-1.5 sm:py-2 bg-[#354EF0] text-[13px] sm:text-[16px] font-medium text-white rounded-lg">Sign up Now</button></Link><div className="text-[10px] sm:text-[12px] font-medium text-[#F5F5F5] pt-1.5 sm:pt-2">Already have an account? <span onClick={() => setLoginPopup(true)} className="text-[10px] sm:text-[12px] font-medium text-[#354EF0] underline cursor-pointer">Login</span></div></div></div>;
    $[27] = getProductFromId;
    $[28] = isFavourite;
    $[29] = isHidden;
    $[30] = isUserLoggedIn;
    $[31] = pathname;
    $[32] = product?.manufacturers;
    $[33] = product?.openfda?.manufacturer_name;
    $[34] = reps;
    $[35] = toggleFavourite;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== hideBorderAndHeading) {
    t13 = !hideBorderAndHeading && <div className="border border-dashed my-3" />;
    $[37] = hideBorderAndHeading;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t13) {
    t14 = <div>{t11}{t12}{t13}</div>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== activeRep?.repDetails?._id || $[44] !== isMsgOpen || $[45] !== product || $[46] !== users?._id) {
    t15 = isMsgOpen && <SendMessage product={product} suggestion={false} senderId={users?._id} isOpen={isMsgOpen} receiverId={activeRep?.repDetails?._id} onClose={() => {
      setIsMsgOpen(false);
      setRepsDetailedPopup(true);
    }} showPredefinedMessage={true} />;
    $[43] = activeRep?.repDetails?._id;
    $[44] = isMsgOpen;
    $[45] = product;
    $[46] = users?._id;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== activeRep?.repDetails || $[49] !== isAppointmentOpen) {
    t16 = isAppointmentOpen && <BookAppointments repData={activeRep?.repDetails} onClose={() => {
      setIsAppointmentOpen(false);
      setRepsDetailedPopup(true);
    }} />;
    $[48] = activeRep?.repDetails;
    $[49] = isAppointmentOpen;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== isLoginPopUpOpen) {
    t17 = isLoginPopUpOpen && <LoginPopup onClose={() => setLoginPopup(false)} />;
    $[51] = isLoginPopUpOpen;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== isAlphaRequestOpen || $[54] !== product) {
    t18 = isAlphaRequestOpen && <AlphaMdRepRequestPopup product={product} onClose={() => setIsAlphaRequestOpen(false)} />;
    $[53] = isAlphaRequestOpen;
    $[54] = product;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== activeRep || $[57] !== isRepsDetailedPopup) {
    t19 = isRepsDetailedPopup && <RepsDetailedPopup openMsg={() => {
      setRepsDetailedPopup(false);
      setIsMsgOpen(true);
    }} rep={activeRep} openAppointment={() => {
      setRepsDetailedPopup(false);
      setIsAppointmentOpen(true);
    }} onClose={() => setRepsDetailedPopup(false)} />;
    $[56] = activeRep;
    $[57] = isRepsDetailedPopup;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== filteredList || $[60] !== load || $[61] !== showList) {
    t20 = showList && <ProductsListingPopUp filteredList={filteredList} loading={load} onClose={() => {
      setFilteredList([]);
      setShowList(false);
      setLoad(false);
    }} />;
    $[59] = filteredList;
    $[60] = load;
    $[61] = showList;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t14 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t18 || $[68] !== t19 || $[69] !== t20) {
    t21 = <>{t14}{t15}{t16}{t17}{t18}{t19}{t20}</>;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
    $[68] = t19;
    $[69] = t20;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  return t21;
};
export default RepsListing;
function _temp(state) {
  return state?.userData?.userData?.user;
}
function _temp2(item) {
  return item.productId;
}
function _temp3(e_0) {
  return e_0.stopPropagation();
}
function _temp4(repProduct, idx) {
  if (repProduct.type) {
    return <Link key={idx} onClick={_temp3} className="px-2 sm:px-4 py-0.5 sm:py-1 text-neutral-400 border text-[10px] sm:text-xs rounded-full font-medium font-poppins whitespace-nowrap text-ellipsis hover:border-[#354EF0]/40 hover:text-[#354EF0]" href={`/products/${repProduct.type}/${repProduct.productAlias}`}>{repProduct.productName}</Link>;
  }
}
function _temp5(item_0) {
  return item_0._id;
}
function _temp6(__0, pidx) {
  return <p key={pidx} className="text-blue-600 underline">{"Humira"}</p>;
}
function _temp7(_, idx_0) {
  return <div key={idx_0} className="w-full p-2 sm:p-3 flex justify-between items-start rounded-lg border border-[#E1E1E1]"><div className="flex items-start gap-2"><div className="w-[36px] h-[36px] sm:w-[48px] sm:h-[48px]"><span className="flex items-center justify-center h-full w-full aspect-square rounded-full bg-green-500 text-white text-sm sm:text-base">J</span></div><div className="space-y-1 sm:space-y-2"><div><div className="flex items-center gap-2"><div className="text-[13px] sm:text-[16px] font-medium text-[#4B4B4B] font-poppins">{"John"}{" "}{"Doe"}</div><div><VerifyAccountIcon /></div></div><div className="text-[10px] sm:text-[12px] font-normal font-poppins text-[#8E8E8E]">{"New York"},{" "}{"US"}</div></div><div className="flex items-center gap-2 sm:gap-3"><div className="text-[12px] sm:text-[14px] font-poppins font-normal text-[#4B4B4B]">Products:</div><div className="text-[#8E8E8E] text-[12px] sm:text-[14px] font-medium font-poppins">{Array.from({
              length: 2
            }).map(_temp6)}</div></div></div></div></div>;
}